import { Injectable } from '@angular/core';
import { Observable } from 'rxjs/Observable';
import { environment } from '../../environments/environment';
import { Product } from '../interfaces/product';
import { HttpClient, HttpParams } from '@angular/common/http';
import { BehaviorSubject } from 'rxjs/BehaviorSubject';
import { ProductSyncStatusInterface } from '../interfaces/product-sync-status.interface';

@Injectable()
export class ProductsService {
  private url: string;
  public currentTriggeredTableSubject$ = new BehaviorSubject<string>('');

  constructor(private http: HttpClient) {
    this.url = environment.PRODUCTS_API_URL;
  }

  getProducts(query: any): Observable<Product[]> {
    const queryParams = new HttpParams().set('filter', JSON.stringify(query));
    return this.http.get<Product[]>(this.url, { params: queryParams });
  }

  getSyncStatuses(): Observable<ProductSyncStatusInterface[]> {
    return this.http.get<ProductSyncStatusInterface[]>(`${this.url}/sync-statuses`);
  }

  getProductById(id: string): Observable<Product> {
    return this.http.get<Product>(`${this.url}/${id}`);
  }

  createProduct(product: Product): Observable<Product> {
    return this.http.post<Product>(this.url, product);
  }

  updateProduct(id: string, product: Product): Observable<Product> {
    return this.http.put<Product>(`${this.url}/${id}`, product);
  }

  deleteProduct(id: string): Observable<Product> {
    return this.http.delete<Product>(`${this.url}/${id}`);
  }
}



// WEBPACK FOOTER //
// ./src/app/services/products.service.ts